import React, { useState, useEffect } from 'react'
import { FaDownload } from 'react-icons/fa'
import Try from '../pages/Try'
import Navbar from '../Components/NavBar'
import Layout from '../Components/Layout'
import Aboutme from '../Components/Aboutme'
import profile from '../images/profilepic.jpg'
import { CSSTransition } from 'react-transition-group'
import '../Responsive.css'
import '../transition.css'
import EducationQualifications from '../Components/timeline/EducationQualifications'

const About = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Layout title="Sarvadnya || About">
      <div className="relative min-h-screen pt-20">
        <Try />
        <Navbar />

        <div className="relative z-10 container mx-auto px-4 py-8 text-white">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600 inline-block">
              ABOUT ME
            </h1>
            <div className="h-1 w-24 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full mt-2"></div>
          </div>

          <CSSTransition in={mounted} timeout={1500} classNames='custom'>
            <div className="flex flex-col lg:flex-row items-center justify-center gap-12 max-w-6xl mx-auto">
              {/* Profile Image Column */}
              <div className="w-full lg:w-1/3 flex flex-col items-center">
                <div className="relative group">
                  <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                  <img
                    src={profile}
                    alt="Sarvadnya Awaghad"
                    className="relative w-64 h-64 lg:w-80 lg:h-80 rounded-full object-cover border-4 border-black/50 shadow-2xl transition-transform duration-500 group-hover:scale-105"
                  />
                </div>

                <a
                  href="/resume.pdf"
                  download="Sarvadnya_Awaghad_CV.pdf"
                  className="mt-8 px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white font-bold shadow-lg hover:shadow-purple-500/50 hover:-translate-y-1 transition-all duration-300 flex items-center gap-2"
                >
                  <FaDownload />
                  Download Resume
                </a>
              </div>

              {/* Content Column */}
              <div className="w-full lg:w-2/3">
                <Aboutme />
              </div>
            </div>
          </CSSTransition>

          <div className="mt-20">
            <EducationQualifications />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default About